import { Box, Button } from "@mui/material";
import { FC } from "react";
import { useThemeContext } from "../../../globalContext/global-context";
import { ActionButtonProps } from "../../../util/types";
import CommonImageComp from "../CommonImageComp";
import { PreviewImageButton } from "../PreviewImageWrapper";
import { actionBtn } from "./styles";

const ActionButton: FC<ActionButtonProps> = ({
  onClick,
  testId,
  currentVal,
  children,
  disabled,
  isSelected,
  style,
  sx,
  buttonImageStyle,
  wrapperSx,
  endIcon,
  ariaLabel,
  ariaPressed,
  ariaDisabled,
  adaptiveText,
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  const image = children ? undefined : currentVal?.image;
  const button = (
    <Button
      type="button"
      data-testid={testId}
      disabled={disabled}
      onClick={ariaDisabled ? undefined : onClick}
      sx={[
        ...(Array.isArray(style)
          ? style
          : [style ?? actionBtn(theme, !!isSelected, currentVal ?? {})]),
        {
          "&:focus-visible": {
            outline: `2px solid ${theme.tokens.color.text.primary}`,
            outlineOffset: "2px",
          },
        },
      ]}
      endIcon={endIcon}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
      aria-disabled={ariaDisabled}
    >
      {children ??
        (currentVal && (
          <CommonImageComp
            currentVal={currentVal}
            isSelected={!!isSelected}
            disabled={disabled}
            sx={sx}
            disablePreviewWrapper={Boolean(image)}
            adaptiveText={adaptiveText}
            imageStyle={{
              ...(buttonImageStyle ?? {
                maxHeight: { xs: "7.9vh", md: "100%" },
                maxWidth: { xs: "100px", md: "100%" },
                backgroundPosition: "cover",
              }),
            }}
          />
        ))}
    </Button>
  );
  if (!image || !currentVal) return button;
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        ...wrapperSx,
        "& .preview-icon": { opacity: 0 },
        "&:hover .preview-icon, &:focus-within .preview-icon": { opacity: 1 },
        "@media (hover: none)": { "& .preview-icon": { opacity: 1 } },
      }}
    >
      {button}
      <PreviewImageButton
        imageToPreview={image}
        altText={currentVal.alt_text || currentVal.text}
      />
    </Box>
  );
};

export default ActionButton;
